import { useState, useEffect, useRef } from "react";

import { API_URL, scroll, isFieldError, getValFromLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import InputUncontrolled from "../components/InputUncontrolled";
import Select from "../components/Select";
import Radios from "../components/Radios";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

// import Ai from "./Ai"; in progress
import Nav from "./Nav";

const Csv = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [report, setReport] = useState({
		generated: false,
	});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/csvInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setDetails({
						types: json.types,
						dates: json.dates,
						venues: json.venues,
					});
					setUser({ ...json.user });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		if (name === "date") {
			const found = details.dates.find((element) => element.id === value);
			const array = found.val.split("-");

			setNames((names) => ({
				...names,
				[name]: value ? value : "",
				start: array[0],
				end: array[1],
			}));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});
		setReport({ generated: false });

		const url = new URL(`${API_URL}/admin/csv`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				if (json.number > 0) {
					setMsg({
						type: "success",
						text: json.text,
					});

					setReport({ ...json.report });
				} else {
					setMsg({
						type: "error",
						text: "There are no records in this export report to display.",
					});
				}
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleClick = () => {
		formElement.current.type.forEach((radio) => {
			radio.checked = false;
		});
		formElement.current.date.value = "";
		formElement.current.venueId.value = "";
		setNames({});
		setReport({ generated: false });
		setMsg({});
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Generate Reports" admin={true} />

						<p>
							Use this form to create .csv export reports for BFC registration
							and sponsor data.
						</p>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div
								className="form-group radios two-column"
								style={{ marginTop: "0", marginBottom: "15px" }}
							>
								<Radios
									label="Select Report Type:"
									reqd={true}
									data={details.types}
									value={""}
									click={handleUpdate}
								/>
							</div>

							<div
								className="form-group"
								style={{
									display:
										names.type === "sponsor" ||
										names.type === "gift" ||
										names.type === "liaison" ||
										names.type === "notused" ||
										names.type === "welcome" ||
										names.type === "participant" ||
										names.type === "venue" ||
										names.type === "course" ||
										names.type === "ids" ||
										names.type === "survey"
											? "none"
											: "flex",
								}}
							>
								<Select
									name="date"
									label="Date Range"
									reqd={true}
									value={""}
									options={details.dates.filter((item) =>
										names.type === "unpaid"
											? item.id === "" ||
											  item.id === "all" ||
											  item.id === "2026"
											: true,
									)}
									update={handleUpdate}
									error={isFieldError(errors, "date")}
								/>
								<div className="empty" />
							</div>

							<div
								className="form-group"
								style={{
									display:
										names.type === "sponsor" ||
										names.type === "gift" ||
										names.type === "liaison" ||
										names.type === "notused" ||
										names.type === "welcome" ||
										names.type === "participant" ||
										names.type === "venue" ||
										names.type === "course" ||
										names.type === "ids" ||
										names.type === "survey" ||
										names.date === "2026"
											? "none"
											: "flex",
								}}
							>
								<InputUncontrolled
									name="start"
									label="Start Date"
									reqd={true}
									value={names.start || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<InputUncontrolled
									name="end"
									label="End Date"
									reqd={true}
									value={names.end || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div
								className="form-group"
								style={{
									display: names.type === "venue" ? "flex" : "none",
								}}
							>
								<Select
									name="venueId"
									label="Select Venue"
									reqd={true}
									value={""}
									options={details.venues}
									update={handleUpdate}
									error={isFieldError(errors, "venueId")}
								/>
								<div className="empty" />
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Generate Report" />
								</div>
							</div>
							{report.generated && (
								<div className="download-container">
									<button type="button" className="naked" onClick={handleClick}>
										<i className="fa fa-times-circle-o fa-lg working" />
									</button>

									<div>
										<i className="fa fa-download fa-3x" />
										<div>
											<a href={report.url} download>
												{report.filename}
											</a>
											<span>{`${report.records} record(s) / ${report.filesize}`}</span>
										</div>
									</div>

									<small>{report.note}</small>
								</div>
							)}
						</form>

						{/* in progress report.url && (
							<Ai csvUrl={report.url} token={getValFromLS("vtoUserToken")} />
						)*/}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={1} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Csv;
